// @core/api/endpoints/platform/set_platform_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformResponse,
  SetPlatformStatusRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Set platform status
 * Changes the platform status to active, suspended, or archived. Suspending a platform temporarily disables access for all members.
 */
export async function SetPlatformStatus(
  platform_id: string,
  data: SetPlatformStatusRequest,
  options?: RequestOptions
): Promise<PlatformResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/status`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.post<PlatformResponse>(requestPath, data, requestOptions);
}
